// extracted by mini-css-extract-plugin
module.exports = {"brandWrap":"Brand_brandWrap__2vgKl","brandText":"Brand_brandText__3yA1b"};